import { SagaIterator } from "redux-saga";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import {
  setDocumentCount,
  setAnnoucementCount,
  setActionLoading,
  updateCommentById,
} from "../../repository/slice";
import { selectComments } from "../../repository/selector";
import toast from "react-hot-toast";
import { tokens } from "../../../../locales/tokens";
import i18next from "i18next";

function* answerCommentWorker({ payload }: any): SagaIterator {
  const { type, ...payloadData } = payload;
  try {
    yield put(setActionLoading(true));

    const commentId = payloadData.parentId;
    const state = yield select(selectComments);
    const comment = state.comments.find((c: any) => c.id === commentId);

    const url =
      type === "document"
        ? `/api/admin/document-comments/answer`
        : `/api/admin/announcement-comments/answer`;
    const { data, message, isError }: IResponse<any> = yield call(
      requester.post,
      url,
      payloadData
    );

    if (!isError) {
      if (comment && !comment.isReadByAdmin) {
        if (type === "document") {
          yield put(setDocumentCount(state.documentCount - 1));
        } else {
          yield put(setAnnoucementCount(state.annoucementCount - 1));
        }
      }

      yield put(
        updateCommentById({
          id: commentId,
          changes: {
            isReadByAdmin: true,
            comments: [...(comment?.comments || []), data],
          },
        })
      );

      toast.success(i18next.t(tokens.comments.successAnswer));
    } else {
      console.error(message);
    }
  } catch (error) {
    console.error("answerCommentWorker: ", error);
  } finally {
    yield put(setActionLoading(false));
  }
}

export function* answerCommentWatcher() {
  yield takeLatest("@saga/ANSWER_COMMENT", answerCommentWorker);
}
